
export const listQuestions = (questions, tag = "[listQuestions]") => {
    for (const question of questions) {
        const key = question.key;
        const position = question.position;
        console.info(`${tag} question ${position} ${key}`);
    }
};
